import scheduleMaintenance from './middleware/scheduleMaintenance'
import provider from './middleware/provider'
import checkAPI from './middleware/checkAPI'
import availableForACU from './middleware/availableForACU'
import availableForProcedure from './middleware/availableForProcedure'

export default [
    // Provider - Dashboard
    {
        path: '/provider',
        name: 'providerDash',
        meta: {
            title: 'Dashboard',
            middleware: [scheduleMaintenance, provider, checkAPI]
        },
        component: () => import('./../components/DashboardProvider/IndexPage.vue'),
        children: [

            // Provider - Provider's Information
            {
                path: 'info',
                name: 'providerInfo',
                meta: {
                    title: 'Provider\'s Information',
                    middleware: [scheduleMaintenance, provider, checkAPI]
                },
                component: () => import('./../components/DashboardProvider/ProviderInfo.vue')
            },

            // Provider - Request Patient Consultation History
            {
                path: 'consultation/history',
                name: 'requestConsultationHistoryProvider',
                meta: {
                    title: 'Consult History',
                    middleware: [scheduleMaintenance, provider, checkAPI]
                },
                component: () => import('./../components/DashboardProvider/ConsultHistory/IndexPage.vue')
            },

            // Provider - Ledger Index
            {
                path: 'ledger',
                name: 'ledgerIndex',
                meta: {
                    title: 'Ledgers',
                    middleware: [scheduleMaintenance, provider, checkAPI]
                },
                component: () => import('./../components/DashboardProvider/Ledger/IndexPage.vue')
            },

            // Provider - Annual Check Up
            {
                path: 'annual-check-up',
                name: 'annualCheckUp',
                meta: {
                    title: 'ACU',
                    middleware: [scheduleMaintenance, provider, checkAPI, availableForACU]
                },
                component: () => import('./../components/DashboardProvider/AnnualCheckUp/IndexPage.vue')
            },

            // Provider - Request Patient Consultation
            {
                path: 'consultation/request',
                name: 'requestConsultationProvider',
                meta: {
                    title: 'Request Patient Consultation',
                    middleware: [scheduleMaintenance, provider, checkAPI]
                },
                component: () => import('./../components/DashboardProvider/RequestConsultation/IndexPage.vue')
            },

            // Provider - Request Patient Procedure
            {
                path: 'procedure/request',
                name: 'requestProcedureProvider',
                meta: {
                    title: 'Request Patient Procedure',
                    middleware: [scheduleMaintenance, provider, checkAPI, availableForProcedure]
                },
                component: () => import('./../components/DashboardProvider/RequestProcedure/IndexPage.vue')
            },

            // Provider - Manage Account
            {
                path: 'manageAccount',
                name: 'manageProviderAccount',
                meta: {
                    title: 'Manage Account',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, provider, checkAPI]
                },
                component: () => import('./../components/DashboardProvider/ManageAccount/IndexPage.vue')
            },

            // Provider - Data Privacy
            {
                path: 'data-privacy',
                meta: {
                    title: 'Data Privacy',
                    requiresAuth : true,
                    middleware: [scheduleMaintenance, provider, checkAPI]
                },
                component: () => import('./../components/DashboardProvider/DataPrivacy.vue')
            }
        ]
    }
]
